import { Navigate, Route, Routes } from 'react-router-dom';
import { AppLayout } from './shared/layout/AppLayout';
import { RequireAuth } from './shared/layout/RequireAuth';
import { AccountPage } from './features/account/AccountPage';
import { AnalysesPage } from './features/analyses/AnalysesPage';
import { GoalsPage } from './features/goals/GoalsPage';
import { CapturePage } from './features/meals/CapturePage';
import { HistoryPage } from './features/meals/HistoryPage';
import { ItemDetailPage } from './features/meals/ItemDetailPage';
import { LabelPage } from './features/meals/LabelPage';
import { LogMealPage } from './features/meals/LogMealPage';
import { MealDetailPage } from './features/meals/MealDetailPage';
import { QuickDayPage } from './features/meals/QuickDayPage';
import { ReprocessPage } from './features/meals/ReprocessPage';
import { MeasurementsPage } from './features/measurements/MeasurementsPage';
import { ProductSearchPage } from './features/products/ProductSearchPage';
import { ContributeProductPage } from '@/features/products/ContributeProductPage';
import { ProfilePage } from './features/profile/ProfilePage';
import { RegisterPage } from './features/auth/RegisterPage';
import { SignInPage } from './features/auth/SignInPage';
import { TodayPage } from './features/today/TodayPage';

export function App() {
  return (
    <Routes>
      <Route path="/ingresar" element={<SignInPage />} />
      <Route path="/registrarse" element={<RegisterPage />} />

      <Route
        element={
          <RequireAuth>
            <AppLayout />
          </RequireAuth>
        }
      >
        <Route path="/" element={<TodayPage />} />
        <Route path="/historial" element={<HistoryPage />} />

        {/* El registro, en el orden en que ocurre: capturar, declarar, revisar. */}
        <Route path="/capturar" element={<CapturePage />} />
        <Route path="/registrar" element={<LogMealPage />} />
        <Route path="/dia" element={<QuickDayPage />} />
        <Route path="/comidas/:mealId" element={<MealDetailPage />} />
        <Route path="/comidas/:mealId/items/:itemId" element={<ItemDetailPage />} />
        <Route path="/comidas/:mealId/items/:itemId/rotulo" element={<LabelPage />} />

        <Route path="/productos/buscar" element={<ProductSearchPage />} />
        <Route path="/productos/aportar" element={<ContributeProductPage />} />
        <Route path="/mediciones" element={<MeasurementsPage />} />
        <Route path="/objetivos" element={<GoalsPage />} />
        <Route path="/analisis" element={<AnalysesPage />} />
        <Route path="/reprocesar" element={<ReprocessPage />} />
        <Route path="/perfil" element={<ProfilePage />} />
        <Route path="/cuenta" element={<AccountPage />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
